(function () {
  if (window.__ccScripts) return;
  window.__ccScripts = true;
  var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observador = null;

  function initReveal(raiz) {
    var els = (raiz || document).querySelectorAll('.cc-reveal:not(.cc-visible)');
    if (!els.length) return;
    if (reducido || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('cc-visible'); });
      return;
    }
    if (!observador) {
      observador = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('cc-visible');
          if (e.target.hasAttribute('data-cc-contar')) contar(e.target);
          e.target.querySelectorAll('[data-cc-contar]').forEach(contar);
          observador.unobserve(e.target);
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) { observador.observe(el); });
  }

  function contar(el) {
    if (el.dataset.ccHecho) return;
    el.dataset.ccHecho = '1';
    var hasta = parseFloat(el.getAttribute('data-cc-contar'));
    if (isNaN(hasta)) return;
    var prefijo = el.getAttribute('data-prefijo') || '';
    var sufijo = el.getAttribute('data-sufijo') || '';
    if (reducido) { el.textContent = prefijo + hasta + sufijo; return; }
    var inicio = null, dur = 1600;
    function paso(t) {
      if (!inicio) inicio = t;
      var p = Math.min((t - inicio) / dur, 1);
      var v = Math.round(hasta * (1 - Math.pow(1 - p, 3)));
      el.textContent = prefijo + v + sufijo;
      if (p < 1) requestAnimationFrame(paso);
    }
    requestAnimationFrame(paso);
    // Por si el navegador frena la animación (pestaña en segundo plano), dejar siempre la cifra final
    setTimeout(function () { el.textContent = prefijo + hasta + sufijo; }, dur + 400);
  }

  function initGaleria(raiz) {
    (raiz || document).querySelectorAll('[data-cc-galeria]').forEach(function (g) {
      if (g.dataset.ccListo) return;
      g.dataset.ccListo = '1';
      var principal = g.querySelector('[data-cc-principal]');
      if (!principal) return;
      g.querySelectorAll('[data-cc-mini]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          g.querySelectorAll('[data-cc-mini]').forEach(function (b) { b.setAttribute('aria-current', 'false'); });
          btn.setAttribute('aria-current', 'true');
          principal.classList.add('cc-cambiando');
          setTimeout(function () {
            principal.src = btn.getAttribute('data-cc-src');
            principal.removeAttribute('srcset');
            principal.alt = btn.getAttribute('data-cc-alt') || '';
            principal.classList.remove('cc-cambiando');
          }, 200);
        });
      });
    });
  }

  function initVariantes(raiz) {
    (raiz || document).querySelectorAll('[data-cc-producto]').forEach(function (cont) {
      if (cont.dataset.ccListo) return;
      cont.dataset.ccListo = '1';
      var datos = cont.querySelector('[data-cc-variantes]');
      if (!datos) return;
      var variantes = JSON.parse(datos.textContent);
      var formato = cont.getAttribute('data-cc-moneda') || '{{amount_with_comma_separator}} €';
      function dinero(c) {
        var n = (c / 100).toFixed(2).replace('.', ',');
        return formato.replace(/\{\{\s*\w+\s*\}\}/, n);
      }
      cont.addEventListener('change', function (ev) {
        if (!ev.target.matches('[data-cc-opcion]')) return;
        var elegidas = [];
        cont.querySelectorAll('fieldset[data-cc-indice]').forEach(function (fs) {
          var marcado = fs.querySelector('input:checked');
          elegidas.push(marcado ? marcado.value : null);
        });
        var v = variantes.find(function (x) {
          return x.options.every(function (o, i) { return o === elegidas[i]; });
        });
        var botones = cont.querySelectorAll('[data-cc-comprar]');
        var precios = document.querySelectorAll('[data-cc-precio]');
        var tachados = document.querySelectorAll('[data-cc-tachado]');
        document.querySelectorAll('input[name="id"][data-cc-id]').forEach(function (inp) { if (v) inp.value = v.id; });
        if (!v) { botones.forEach(function (b) { b.disabled = true; }); return; }
        precios.forEach(function (p) { p.textContent = dinero(v.price); });
        tachados.forEach(function (t) {
          if (v.compare_at_price && v.compare_at_price > v.price) { t.textContent = dinero(v.compare_at_price); t.hidden = false; }
          else { t.hidden = true; }
        });
        botones.forEach(function (b) {
          b.disabled = !v.available;
          var txt = b.querySelector('[data-cc-txt]');
          if (txt) txt.textContent = v.available ? b.getAttribute('data-cc-txt-ok') : b.getAttribute('data-cc-txt-agotado');
        });
        if (v.featured_image) {
          var principal = cont.querySelector('[data-cc-principal]');
          if (principal) { principal.removeAttribute('srcset'); principal.src = v.featured_image.src; }
        }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      });
    });
  }

  function initBarra() {
    var barra = document.querySelector('[data-cc-barra]');
    var ancla = document.querySelector('[data-cc-ancla-compra]');
    if (!barra || !ancla) return;
    var pendiente = false;
    function revisar() {
      pendiente = false;
      barra.classList.toggle('cc-visible', ancla.getBoundingClientRect().bottom < 0);
    }
    window.addEventListener('scroll', function () {
      if (!pendiente) { pendiente = true; requestAnimationFrame(revisar); }
    }, { passive: true });
    revisar();
  }

  function initTodo(raiz) {
    initReveal(raiz);
    initGaleria(raiz);
    initVariantes(raiz);
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (window.Shopify && Shopify.designMode) document.documentElement.classList.add('shopify-design-mode');
    initTodo(document);
    initBarra();
  });
  document.addEventListener('shopify:section:load', function (e) { initTodo(e.target); });
})();
